import React, { Component } from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { INTERVENTION_CATEGORIES } from '../Interventions/constants'
import connexion from '../../connexion'
import OnlyPremiumEmpty from '../UI/OnlyPremiumEmpty'
import PremiumAlert from '../UI/PremiumAlert'

const QUICK_REPLIES = [
	"Un agent va se rendre à votre emplacement.",
	"Nous avons bien pris en compte votre demande.",
	"Incident résolu, bonne journée !"
]

const INCIDENT_TYPES = ['Électricité', 'Plomberie', 'Mobilier', 'Gaz', 'Wifi', 'Fuite', 'Voisinage', 'Casse', 'Autre']

// Correspondance type d'incident (messagerie) → catégorie du module Interventions
const INCIDENT_TO_CATEGORY = {
	'Électricité': 'Électricité',
	'Plomberie': 'Plomberie',
	'Mobilier': 'Mobilier',
	'Gaz': 'Gaz',
	'Fuite': 'Plomberie',
	'Voisinage': 'Sécurité',
	'Casse': 'Entretien Général',
}

const URGENCY_CONFIG = {
	NORMAL:    { label: 'Normal',    activeCls: 'bg-blue-50 border-blue-600 text-blue-700',   activeBg: '#eff6ff', icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' },
	IMPORTANT: { label: 'Important', activeCls: 'bg-orange-50 border-orange-600 text-orange-700', activeBg: '#fff7ed', icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z' },
	CRITICAL:  { label: 'Urgent',    activeCls: 'bg-red-50 border-red-600 text-red-700',      activeBg: '#fef2f2', icon: 'M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01' },
}

// ── Date helpers ──────────────────────────────────────────────────

function isToday(d) {
	const n = new Date()
	return d.getDate() === n.getDate() && d.getMonth() === n.getMonth() && d.getFullYear() === n.getFullYear()
}

function isYesterday(d) {
	const y = new Date()
	y.setDate(y.getDate() - 1)
	return d.getDate() === y.getDate() && d.getMonth() === y.getMonth() && d.getFullYear() === y.getFullYear()
}

const DAYS_FR = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
const MONTHS_FR = ['jan', 'fév', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sep', 'oct', 'nov', 'déc']

function formatListDate(ts) {
	if (!ts) return ''
	const d = new Date(ts * 1000)
	if (isToday(d))
		return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0')
	if (isYesterday(d)) return 'hier'
	if ((new Date() - d) < 7 * 86400 * 1000) return DAYS_FR[d.getDay()]
	return d.getDate() + ' ' + MONTHS_FR[d.getMonth()]
}

function formatTime(ts) {
	if (!ts) return ''
	const d = new Date(ts * 1000)
	return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0')
}

function getInitials(name) {
	if (!name) return '?'
	const parts = name.trim().split(' ').filter(Boolean)
	if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
	return parts[0][0].toUpperCase()
}

// ── SVG icons ─────────────────────────────────────────────────────

const ISearch = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M17 11A6 6 0 1 0 5 11a6 6 0 0 0 12 0z" />
	</svg>
)

const IGear = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
	</svg>
)

const ISend = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
	</svg>
)

const IAlert = ({ size = "w-2.5 h-2.5" }) => (
	<svg className={size} fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<circle cx="12" cy="12" r="10" strokeWidth={2} />
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4M12 16h.01" />
	</svg>
)

const IMsg = ({ size = "w-2.5 h-2.5" }) => (
	<svg className={size} fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
	</svg>
)

const IChevDown = ({ cls = "w-3 h-3" }) => (
	<svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
	</svg>
)


const IPhone = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 0 1 2-2h3.28a1 1 0 0 1 .948.684l1.498 4.493a1 1 0 0 1-.502 1.21l-2.257 1.13a11.042 11.042 0 0 0 5.516 5.516l1.13-2.257a1 1 0 0 1 1.21-.502l4.493 1.498a1 1 0 0 1 .684.949V19a2 2 0 0 1-2 2h-1C9.716 21 3 14.284 3 6V5z" />
	</svg>
)

const IMail = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 0 0 2.22 0L21 8M5 19h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z" />
	</svg>
)

const IPin = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 0 1-2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0z" />
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
	</svg>
)

const IHome = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 22V12h6v10" />
	</svg>
)

const ICal = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<rect x="3" y="4" width="18" height="18" rx="2" ry="2" strokeWidth={2} />
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 2v4M8 2v4M3 10h18" />
	</svg>
)

const IFilePlus = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 2v6h6M12 18v-6M9 15h6" />
	</svg>
)

const IClip = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
	</svg>
)

const IId = () => (
	<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0M9 12h.01M15 12h.01M9 16h6" />
	</svg>
)

// ── StatusBadge ───────────────────────────────────────────────────

function StatusBadge({ type, incidentType }) {
	if (type === 'intervention')
	{
		return (
			<span className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded ring-1 ring-orange-200">
				<IAlert />
				Incident{incidentType ? `: ${incidentType}` : ''}
			</span>
		)
	}
	return (
		<span className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded">
			<IMsg />
			Chat
		</span>
	)
}

// ── Dropdown component ────────────────────────────────────────────

function Dropdown({ isOpen, onClose, items, title, children }) {
	return (
		<div className="relative">
			{children}
			{isOpen && (
				<div className="absolute top-full right-0 mt-1 bg-white rounded-lg shadow-lg border border-slate-200 z-50 py-1 min-w-[160px]">
					{title && (
						<>
							<p className="px-3 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wider">{title}</p>
							<hr className="border-slate-100 my-1" />
						</>
					)}
					{items.map(item => (
						<div
							key={item.value}
							onClick={() => { item.onSelect(); onClose() }}
							className="px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer transition-colors"
						>
							{item.label}
						</div>
					))}
				</div>
			)}
		</div>
	)
}

// ── Main component ────────────────────────────────────────────────

class MessagerieAll extends Component
{
	constructor(props)
	{
		super(props)
		this.state = {
			conversations: [],
			messagesMap: {},
			activeConversationId: null,
			searchQuery: '',
			searchFocused: false,
			textareaFocused: false,
			filterType: 'all',
			// true dès le départ : le loader s'affiche jusqu'au retour de l'API
			loading: true,
			loadingMessages: false,
			inputText: '',
			openDropdown: null,
			apiLoaded: false,
			creatingTicket: false,
			ticketFeedback: null,
			showTicketDialog: false,
			ticketDraft: null,
			ticketCategoryOpen: false,
			ticketCategorySearch: '',
			ticketLieuOpen: false,
			notesMap: {},
			noteInput: '',
			noteFocused: false,
			loadingNotes: false,
			isNarrow: (typeof window !== 'undefined' && window.matchMedia) ? window.matchMedia('(max-width: 1023px)').matches : false,
			// true seulement si la conversation active a été ouverte par un clic délibéré,
			// false lors de l'auto-ouverture au chargement → on ne marque pas lu sans action
			activeUserOpened: false,
		}
		this.scrollRef = React.createRef()
		this.pollTimer = null
		this.lastConversationsSync = 0
		this.lastMessageSync = 0
		this._narrowMql = null
		this.props.updateNavbarTitle('Messagerie')
	}

	// Suit le passage sous le point de rupture lg (1024 px) pour piloter l'offset
	// de gauche du plein écran (la sidebar dashboard est masquée < lg → offset 0)
	_handleNarrowChange = (e) => {
		this.setState({ isNarrow: e.matches })
	}

	_resetPollTimer = (hasActiveConversation) => {
		if (this.pollTimer)
			clearInterval(this.pollTimer)
		const interval = hasActiveConversation ? 3000 : 30000
		this.pollTimer = setInterval(this._poll, interval)
	}

	componentDidMount()
	{
		this._loadConversations()
		// charge la liste de l'équipe (pour résoudre le prénom de l'agent sous chaque message)
		// si elle n'a pas déjà été chargée ailleurs dans le dashboard
		if ((!this.props.dashboard_users || this.props.dashboard_users.length === 0) && this.props.fetchDashboardUsers)
			this.props.fetchDashboardUsers().catch(() => {})
		// notif navigateur : demande la permission une fois (best-effort)
		if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'default')
		{
			try { Notification.requestPermission() }
			catch (e) { /* certains navigateurs exigent un geste utilisateur : ignoré */ }
		}
		document.addEventListener('click', this._handleDocClick)
		// suit le point de rupture lg pour l'offset du plein écran sur mobile
		if (typeof window !== 'undefined' && window.matchMedia)
		{
			this._narrowMql = window.matchMedia('(max-width: 1023px)')
			if (this._narrowMql.addEventListener)
				this._narrowMql.addEventListener('change', this._handleNarrowChange)
			else if (this._narrowMql.addListener)
				this._narrowMql.addListener(this._handleNarrowChange) // repli Safari ancien
		}
		this._resetPollTimer(false)
	}

	componentWillUnmount()
	{
		document.removeEventListener('click', this._handleDocClick)
		if (this.pollTimer)
			clearInterval(this.pollTimer)
		if (this._narrowMql)
		{
			if (this._narrowMql.removeEventListener)
				this._narrowMql.removeEventListener('change', this._handleNarrowChange)
			else if (this._narrowMql.removeListener)
				this._narrowMql.removeListener(this._handleNarrowChange)
		}
	}

	componentDidUpdate(_, prevState)
	{
		const { activeConversationId, messagesMap } = this.state
		if (!activeConversationId) return
		const prev = prevState.messagesMap[activeConversationId]
		const curr = messagesMap[activeConversationId]
		if (curr !== prev || prevState.activeConversationId !== activeConversationId)
			this._scrollToBottom()
	}

	// "Pop / blop" façon Messenger, généré via Web Audio (pas de fichier asset).
	// Hauteur qui plonge rapidement + enveloppe attaque nette / extinction courte.
	_playBeep = () => {
		try
		{
			const Ctx = window.AudioContext || window.webkitAudioContext
			if (!Ctx)
				return
			const ctx = new Ctx()
			const now = ctx.currentTime
			const osc = ctx.createOscillator()
			const gain = ctx.createGain()
			osc.type = 'sine'
			// pitch drop 520 → 160 Hz : le "bloop" caractéristique
			osc.frequency.setValueAtTime(520, now)
			osc.frequency.exponentialRampToValueAtTime(160, now + 0.12)
			// enveloppe de gain : montée quasi instantanée puis extinction rapide
			gain.gain.setValueAtTime(0.0001, now)
			gain.gain.exponentialRampToValueAtTime(0.12, now + 0.012)
			gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.18)
			osc.connect(gain)
			gain.connect(ctx.destination)
			osc.start(now)
			osc.stop(now + 0.2)
			osc.onended = () => { try { ctx.close() } catch (e) {} }
		}
		catch (e) { /* audio indisponible : ignoré */ }
	}

	// Notif à l'arrivée d'un/des nouveaux messages vacancier (hors conversation ouverte)
	// Son désactivé pour le moment (voir _playBeep, conservé pour réactivation ultérieure)
	_notifyNewMessages = (convs) => {
		if (!convs || convs.length === 0)
			return
		if (typeof window === 'undefined' || !('Notification' in window) || Notification.permission !== 'granted')
			return
		try
		{
			const first = convs[0]
			const title = (convs.length > 1)
				? (convs.length + ' nouveaux messages')
				: 'Nouveau message'
			const body = (convs.length > 1)
				? 'Plusieurs vacanciers vous ont écrit'
				: ((first.guestName ? first.guestName + ' : ' : '') + (first.title || 'Nouveau message'))
			const notif = new Notification(title, { body: body, tag: 'pocketcamp-messagerie' })
			notif.onclick = () => {
				try { window.focus() } catch (e) {}
				if (convs.length === 1)
					this._handleSelectConversation(first._id)
				notif.close()
			}
		}
		catch (e) { /* échec silencieux */ }
	}

	_scrollToBottom = () => {
		if (this.scrollRef.current)
			this.scrollRef.current.scrollTop = this.scrollRef.current.scrollHeight
	}

	_handleDocClick = (e) => {
		if (!e.target.closest('[data-dd]'))
			this.setState({ openDropdown: null })
		if (!e.target.closest('[data-dd-cat]'))
			this.setState({ ticketCategoryOpen: false })
		if (!e.target.closest('[data-dd-loc]'))
			this.setState({ ticketLieuOpen: false })
	}

	// Emplacement valide = correspondance exacte (insensible à la casse) avec un pitch
	_matchPitch = (input) => {
		const q = (input || '').trim().toLowerCase()
		if (!q)
			return null
		return (this.props.pitches || []).find(p => (p.location || '').toLowerCase() === q) || null
	}

	// Horodatage d'activité d'une conversation : dernière édition ou création
	_convActivity = (conv) => {
		const edited = conv.edited_time || 0
		const created = conv.created_time || 0
		return (edited > created) ? edited : created
	}

	_computeConvSync = (conversations) => {
		let last = 0
		for (let i = 0; i < conversations.length; i++)
		{
			const activity = this._convActivity(conversations[i])
			if (activity > last)
				last = activity
		}
		return last
	}

	_computeLastSync = (messages) => {
		let last = 0
		for (let i = 0; i < messages.length; i++)
		{
			if (messages[i].created_time && messages[i].created_time > last)
				last = messages[i].created_time
		}
		return last
	}

	_guessIncidentType = (title) => {
		if (!title) return null
		const t = title.toLowerCase()
		if (t.includes('équipement') || t.includes('equipment')) return 'Mobilier'
		if (t.includes('plomberie') || t.includes('plumbing')) return 'Plomberie'
		if (t.includes('fuite') || t.includes('leak')) return 'Fuite'
		if (t.includes('gaz') || t.includes('gas')) return 'Gaz'
		if (t.includes('cassé') || t.includes('broken')) return 'Casse'
		return null
	}

	_resolveStay = (user, stays) => {
		if (!user || !user.stay)
			return null
		const raw = user.stay
		const first = Array.isArray(raw) ? raw[0] : raw
		if (!first)
			return null
		if (typeof first === 'object' && first.location)
			return first
		const stayNumber = (typeof first === 'object') ? first.stay_number : first
		if (stayNumber == null)
			return null
		for (let i = 0; i < stays.length; i++)
		{
			if (stays[i].stay_number === stayNumber || String(stays[i].stay_number) === String(stayNumber))
				return stays[i]
		}
		return null
	}

	_decorate = (conv, users, stays) => {
		let user = null
		for (let i = 0; i < users.length; i++)
		{
			if (String(users[i]._id) === String(conv.user))
			{
				user = users[i]
				break
			}
		}
		const stay = this._resolveStay(user, stays)
		const guestName = user ? ((user.firstname || '') + ' ' + (user.lastname || '')).trim() : null
		const incident_type = conv.incident_type || (conv.type === 'intervention' ? this._guessIncidentType(conv.title) : null)
		return {
			...conv,
			_id: String(conv._id),
			read: conv.read !== false,
			is_archived: conv.is_archived === true,
			status: conv.status || 'open',
			incident_type: incident_type,
			guestName: guestName || (user ? user.email : null),
			guestPhone: user ? user.phone : null,
			guestEmail: user ? user.email : null,
			clientNumber: (user && user.client_number != null) ? String(user.client_number) : null,
			pitch: (stay && stay.location) ? stay.location : null,
			stayCategory: (stay && stay.location_category) ? stay.location_category : null,
			stayDates: (stay && stay.arrival && stay.departure) ? stay.arrival + ' → ' + stay.departure : null,
		}
	}

	_fetchStays = () => {
		return fetch(connexion.connect.url + 'dashboard/stays/list')
		.then(res => res.json())
		.then(stays => {
			this._stays = stays || []
			return this._stays
		})
		.catch(() => {
			this._stays = []
			return []
		})
	}

	_loadConversations = () => {
		if (!this.props.fetchConversations)
			return
		this.setState({ loading: true })
		const usersPromise = (this.props.webapp_users) ? Promise.resolve(this.props.webapp_users) : this.props.fetchWebappUsers()
		const pitchesPromise = (this.props.pitches) ? Promise.resolve(this.props.pitches) : this.props.fetchPitches()
		const staysPromise = (this._stays && this._stays.length > 0) ? Promise.resolve(this._stays) : this._fetchStays()
		Promise.all([this.props.fetchConversations(), usersPromise, pitchesPromise, staysPromise])
		.then(([conversations, users, _pitches, stays]) => {
			const decorated = (conversations || []).map(c => this._decorate(c, users || [], stays || []))
			this.lastConversationsSync = this._computeConvSync(decorated)
			this.setState({
				conversations: decorated,
				messagesMap: {},
				loading: false,
				apiLoaded: true
			}, () => {
				// Ouverture directe d'une conversation (ex. lien « Voir la demande client »
				// depuis une fiche intervention) via l'état de navigation du routeur
				const nav_state = (this.props.location && this.props.location.state) || {}
				const wanted = nav_state.openConversationId
					? (this.state.conversations || []).find(c => String(c._id) === String(nav_state.openConversationId))
					: null
				if (wanted)
				{
					this._handleSelectConversation(wanted._id, true)
					return
				}
				const first = this._getFiltered()[0]
				if (first)
					this._handleSelectConversation(first._id, false)
			})
		})
		.catch(err => {
			console.log("could not load conversations", err)
			this.setState({ loading: false })
		})
	}

	_loadMessages = (id, silent = false) => {
		if (!this.props.fetchMessagesByConversation || !this.state.apiLoaded)
			return
		if (!silent)
			this.setState({ loadingMessages: true })
		this.props.fetchMessagesByConversation(id)
		.then(messages => {
			const sorted = (messages || []).slice().sort((a, b) => (a.created_time || 0) - (b.created_time || 0))
			this.lastMessageSync = this._computeLastSync(sorted)
			this.setState(prev => ({
				messagesMap: { ...prev.messagesMap, [id]: sorted },
				loadingMessages: false
			}))
		})
		.catch(err => {
			console.log("could not load messages", err)
			this.setState({ loadingMessages: false })
		})
	}

	// Rafraîchissement périodique (même logique que la webapp) :
	// récupère uniquement les conversations/messages modifiés depuis le dernier sync.
	_poll = () => {
		this._pollConversations()
		this._pollMessages()
	}

	// Delta des conversations modifiées depuis lastConversationsSync, fusionnées par _id.
	_pollConversations = () => {
		if (!navigator.onLine)
			return
		if (!this.state.apiLoaded || !this.props.pollConversations)
			return
		const users = this.props.webapp_users || []
		const stays = this._stays || []
		this.props.pollConversations(this.lastConversationsSync)
		.then(delta => {
			if (!delta || delta.length === 0)
				return
			// détecte les conversations qui deviennent non-lues (nouveau message vacancier),
			// hors conversation ouverte, pour déclencher son + notif navigateur
			const prevById = {}
			for (let i = 0; i < this.state.conversations.length; i++)
				prevById[this.state.conversations[i]._id] = this.state.conversations[i]
			const toNotify = []
			for (let i = 0; i < delta.length; i++)
			{
				const decorated = this._decorate(delta[i], users, stays)
				if (decorated._id === this.state.activeConversationId)
					continue
				if (decorated.read === false)
				{
					const previous = prevById[decorated._id]
					if (!previous || previous.read !== false)
						toNotify.push(decorated)
				}
			}
			this.setState(prev => {
				const indexById = {}
				const merged = prev.conversations.slice()
				for (let i = 0; i < merged.length; i++)
					indexById[merged[i]._id] = i
				for (let i = 0; i < delta.length; i++)
				{
					const decorated = this._decorate(delta[i], users, stays)
					if (decorated._id === prev.activeConversationId && prev.activeUserOpened)
						decorated.read = true
					if (indexById[decorated._id] !== undefined)
						merged[indexById[decorated._id]] = decorated
					else
						merged.push(decorated)
				}
				return { conversations: merged }
			}, () => {
				this.lastConversationsSync = this._computeConvSync(this.state.conversations)
				this._notifyNewMessages(toNotify)
			})
		})
		.catch(() => {})
	}

	// Delta des messages de la conversation ouverte depuis lastMessageSync, fusionnés par _id.
	_pollMessages = () => {
		if (!navigator.onLine)
			return
		const id = this.state.activeConversationId
		if (!id || !this.state.apiLoaded || !this.props.pollMessagesByConversation)
			return
		this.props.pollMessagesByConversation(id, this.lastMessageSync)
		.then(incoming => {
			if (!incoming || incoming.length === 0)
				return
			// ne marque lu à l'arrivée d'un message que si la conversation a été
			// ouverte délibérément (pas juste auto-ouverte au chargement)
			if (this.state.activeUserOpened)
				this._persistUpdate(id, { read: true })
			this.setState(prev => {
				const existing = {}
				const current = prev.messagesMap[id] || []
				for (let i = 0; i < current.length; i++)
					existing[current[i]._id] = true
				const merged = current.slice()
				for (let i = 0; i < incoming.length; i++)
				{
					if (!existing[incoming[i]._id])
						merged.push(incoming[i])
				}
				merged.sort((a, b) => (a.created_time || 0) - (b.created_time || 0))
				return { messagesMap: { ...prev.messagesMap, [id]: merged } }
			}, () => {
				this.lastMessageSync = this._computeLastSync(this.state.messagesMap[id] || [])
			})
		})
		.catch(() => {})
	}

	_persistUpdate = (id, fields) => {
		if (!this.state.apiLoaded || !this.props.updateConversationDashboard)
			return
		this.props.updateConversationDashboard(id, fields)
		.catch(err => console.log("could not update conversation", err))
	}

	// Mobile : revient à la liste (le master-detail affiche liste OU chat < lg)
	_handleBackToList = () => {
		this.setState({ activeConversationId: null }, () => this._resetPollTimer(false))
	}

	// byUser = true : sélection par clic (liste / notification) → marque lu.
	// byUser = false : auto-ouverture au chargement → affiche sans marquer lu.
	_handleSelectConversation = (id, byUser = true) => {
		const conv = (this.state.conversations || []).find(c => c._id === id)
		this.setState(prev => ({
			activeConversationId: id,
			activeUserOpened: byUser,
			inputText: '',
			openDropdown: null,
			ticketFeedback: null,
			conversations: (prev.conversations || []).map(c =>
				(c._id === id && byUser) ? { ...c, read: true } : c
			)
		}))
		this._resetPollTimer(true)
		if (byUser && conv && conv.read === false)
			this._persistUpdate(id, { read: true })
		if (!this.state.messagesMap[id])
			this._loadMessages(id)
		else
			this.lastMessageSync = this._computeLastSync(this.state.messagesMap[id])
		this.setState({ noteInput: '' })
		if (this.state.notesMap[id] === undefined)
			this._loadNotes(id)
	}

	// ── Notes internes d'équipe ───────────────────────────────────────

	_loadNotes = (id) => {
		if (!this.props.fetchConversationNotes || !this.state.apiLoaded)
			return
		this.setState({ loadingNotes: true })
		this.props.fetchConversationNotes(id)
		.then(notes => {
			const sorted = (Array.isArray(notes) ? notes : []).slice().sort((a, b) => (a.created_time || 0) - (b.created_time || 0))
			this.setState(prev => ({
				notesMap: { ...prev.notesMap, [id]: sorted },
				loadingNotes: false
			}))
		})
		.catch(() => this.setState({ loadingNotes: false }))
	}

	_handleAddNote = () => {
		const { noteInput, activeConversationId } = this.state
		const text = (noteInput || '').trim()
		if (!text || !activeConversationId || !this.props.insertConversationNote)
			return
		const now = Math.round(Date.now() / 1000)
		const optimistic = {
			_id: 'tmp_note_' + Date.now(),
			conversation: activeConversationId,
			note: text,
			staff_user: (this.props.user && this.props.user._id) ? String(this.props.user._id) : null,
			created_time: now
		}
		this.setState(prev => ({
			notesMap: { ...prev.notesMap, [activeConversationId]: [...(prev.notesMap[activeConversationId] || []), optimistic] },
			noteInput: ''
		}))
		this.props.insertConversationNote(activeConversationId, text)
		.then(saved => {
			if (!saved)
				return
			this.setState(prev => ({
				notesMap: {
					...prev.notesMap,
					[activeConversationId]: (prev.notesMap[activeConversationId] || []).map(n =>
						n._id === optimistic._id ? saved : n
					)
				}
			}))
		})
		.catch(() => {})
	}

	_handleDeleteNote = (noteId) => {
		const { activeConversationId } = this.state
		if (!activeConversationId)
			return
		this.setState(prev => ({
			notesMap: {
				...prev.notesMap,
				[activeConversationId]: (prev.notesMap[activeConversationId] || []).filter(n => n._id !== noteId)
			}
		}))
		if (this.props.deleteConversationNote && String(noteId).indexOf('tmp_note_') !== 0)
			this.props.deleteConversationNote(noteId).catch(() => {})
	}

	_handleSendMessage = (textOverride) => {
		const text = textOverride !== undefined ? textOverride : this.state.inputText
		if (!text.trim()) return
		const { activeConversationId } = this.state
		if (!activeConversationId) return

		const now = Math.round(Date.now() / 1000)
		const optimistic = {
			_id: 'tmp_' + Date.now(),
			conversation: activeConversationId,
			message: text,
			sender_type: 'staff',
			user: null,
			staff_user: (this.props.user && this.props.user._id) ? String(this.props.user._id) : null,
			created_time: now
		}

		this.setState(prev => ({
			messagesMap: {
				...prev.messagesMap,
				[activeConversationId]: [...(prev.messagesMap[activeConversationId] || []), optimistic]
			},
			inputText: textOverride !== undefined ? prev.inputText : ''
		}))

		if (this.props.insertStaffMessage && this.state.apiLoaded)
		{
			this.props.insertStaffMessage(activeConversationId, text)
			.then(message => {
				if (!message) return
				if (message.created_time && message.created_time > this.lastMessageSync)
					this.lastMessageSync = message.created_time
				this.setState(prev => ({
					messagesMap: {
						...prev.messagesMap,
						[activeConversationId]: (prev.messagesMap[activeConversationId] || []).map(m =>
							m._id === optimistic._id ? message : m
						)
					}
				}))
			})
			.catch(() => {})
		}
	}


	_handleUpdate = (fields) => {
		const { activeConversationId } = this.state
		if (!activeConversationId) return
		this.setState(prev => ({
			conversations: (prev.conversations || []).map(c =>
				c._id === activeConversationId ? { ...c, ...fields } : c
			)
		}))
		this._persistUpdate(activeConversationId, fields)
	}

	_handleArchive = () => {
		const { activeConversationId } = this.state
		if (!activeConversationId) return
		this.setState(prev => ({
			conversations: (prev.conversations || []).map(c =>
				c._id === activeConversationId ? { ...c, is_archived: true, status: 'resolved' } : c
			),
			activeConversationId: null
		}))
		this._resetPollTimer(false)
		this._persistUpdate(activeConversationId, { is_archived: true, status: 'resolved' })
	}

	_handleOpenTicketDialog = () => {
		const { activeConversationId, conversations, creatingTicket } = this.state
		if (creatingTicket || !this.props.insertIntervention) return
		const conv = (conversations || []).find(c => c._id === activeConversationId)
		if (!conv || conv.ticket_created) return
		const user = this.props.user
		const userName = user ? (((user.firstname || '') + ' ' + (user.lastname || '')).trim() || user.email) : ''
		// pré-remplit la description avec le 1er message de la conversation du vacancier
		const messages = this.state.messagesMap[activeConversationId] || []
		let first_message = null
		for (let i = 0; i < messages.length; i++)
		{
			if (!first_message || (messages[i].created_time || 0) < (first_message.created_time || 0))
				first_message = messages[i]
		}
		const description = (first_message && first_message.message) ? first_message.message : conv.title
		const now = new Date()
		const ticketDraft = {
			_pitchInput: conv.pitch || '',
			conversation_id: String(conv._id),
			created_by: user ? String(user._id) : null,
			// vacancier à l'origine de la conversation (son _id) ; le dashboard résout
			// son prénom + nom côté serveur pour afficher le "Créateur"
			created_user_by: conv.user || null,
			created_time: Math.round(now.getTime() / 1000),
			client_number: conv.clientNumber ? parseInt(conv.clientNumber, 10) : null,
			label: conv.incident_type ? 'Incident : ' + conv.incident_type : 'Incident vacancier',
			description: description,
			location_id: null,
			type: 'Technique',
			status: 'TODO',
			urgency: 'NORMAL',
			category: INCIDENT_TO_CATEGORY[conv.incident_type] || null,
			equipment: null,
			estimated_duration: null,
			deadline: null,
			is_customer_request: true,
			customer_permission: true,
			assigned_to: null,
			photo_urls: [],
			history: [
				{
					id: Math.random().toString(36).substr(2, 5),
					type: 'creation',
					user: userName,
					timestamp: now.toISOString(),
					details: 'Ticket créé depuis la messagerie (conversation de ' + (conv.guestName || 'vacancier') + ')'
				}
			]
		}
		this.setState({ showTicketDialog: true, ticketDraft, ticketFeedback: null, ticketCategoryOpen: false, ticketCategorySearch: '', ticketLieuOpen: false })
	}

	_handleConfirmTicket = () => {
		const { ticketDraft, activeConversationId, creatingTicket } = this.state
		if (!ticketDraft || creatingTicket) return
		// location_id est obligatoire côté modèle : sans correspondance exacte,
		// le bouton est désactivé — ce garde-fou couvre le cas résiduel
		const matched = this._matchPitch(ticketDraft._pitchInput)
		if (!matched) return
		const { _pitchInput, ...intervention } = ticketDraft
		intervention.location_id = String(matched._id)
		this.setState({ creatingTicket: true })
		this.props.insertIntervention(intervention)
		.then(ret => {
			if (ret === false)
			{
				this.setState({ creatingTicket: false, showTicketDialog: false, ticketFeedback: { type: 'error', text: "Échec de la création du ticket" } })
				return
			}
			this.setState(prev => ({
				creatingTicket: false,
				showTicketDialog: false,
				ticketDraft: null,
				ticketFeedback: { type: 'success', text: "Ticket créé dans le module Interventions" },
				conversations: (prev.conversations || []).map(c =>
					c._id === activeConversationId ? { ...c, ticket_created: true, status: 'in_progress' } : c
				)
			}))
			this._persistUpdate(activeConversationId, { status: 'in_progress', ticket_created: true })
		})
		.catch(() => {
			this.setState({ creatingTicket: false, showTicketDialog: false, ticketFeedback: { type: 'error', text: "Échec de la création du ticket" } })
		})
	}

	_renderTicketDialog = () => {
		const { showTicketDialog, ticketDraft, creatingTicket, ticketCategoryOpen, ticketCategorySearch } = this.state
		if (!showTicketDialog || !ticketDraft) return null

		const sectionLabel = { display: 'block', fontSize: '0.875rem', fontWeight: 900, color: '#1e293b', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.5rem' }
		const inputCls = 'browser-default'
		const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '1rem', border: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0', borderRadius: '1rem', fontSize: '1rem', fontWeight: 600, color: '#1e293b', outline: 'none', boxShadow: '0 1px 2px rgba(0,0,0,0.04)', background: 'white', transition: 'border-color 0.15s' }
		const onFocus = e => { e.target.style.borderColor = '#3b82f6'; e.target.style.borderBottomColor = '#3b82f6' }
		const onBlur = e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.borderBottomColor = '#e2e8f0' }

		return (
			<div
				onClick={e => { if (e.target === e.currentTarget) this.setState({ showTicketDialog: false }) }}
				style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 200, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}
			>
				<div style={{ background: 'white', borderRadius: '1.5rem', boxShadow: '0 25px 50px rgba(0,0,0,0.25)', width: '100%', maxWidth: '34rem', maxHeight: 'calc(100% - 2rem)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

					{/* Header */}
					<div style={{ padding: '1.5rem 1.5rem 1.25rem', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
							<span style={{ width: '2rem', height: '2rem', background: '#2563eb', color: 'white', borderRadius: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', fontWeight: 700, flexShrink: 0 }}>
								<IFilePlus />
							</span>
							<div>
								<p style={{ margin: 0, fontSize: '1rem', fontWeight: 900, color: '#0f172a', lineHeight: 1.2 }}>Nouvelle intervention</p>
								<p style={{ margin: 0, fontSize: '0.6875rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Depuis la messagerie</p>
							</div>
						</div>
						<button
							onClick={() => this.setState({ showTicketDialog: false })}
							style={{ backgroundImage: 'none', backgroundColor: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer', padding: '0.25rem' }}
						>
							<svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
						</button>
					</div>

					{/* Body */}
					<div style={{ flex: 1, overflowY: 'auto', padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>

						{/* Description */}
						<section>
							<label style={sectionLabel}>Description / Précision</label>
							<textarea
								className={inputCls}
								value={ticketDraft.description}
								onChange={e => { const v = e.target.value; this.setState(prev => ({ ticketDraft: { ...prev.ticketDraft, description: v } })) }}
								onFocus={onFocus}
								onBlur={onBlur}
								rows={3}
								placeholder="Décrire simplement le problème..."
								style={{ ...inputStyle, resize: 'vertical', minHeight: '5rem' }}
							/>
						</section>

						{/* Localisation — correspondance obligatoire avec un emplacement existant */}
						<section data-dd-loc>
							<label style={sectionLabel}>Localisation</label>
							<div data-dd-loc style={{ position: 'relative' }}>
								<input
									className={inputCls}
									data-dd-loc
									type="text"
									value={ticketDraft._pitchInput}
									onChange={e => { const v = e.target.value; this.setState(prev => ({ ticketDraft: { ...prev.ticketDraft, _pitchInput: v }, ticketLieuOpen: true })) }}
									onFocus={() => this.setState({ ticketLieuOpen: true })}
									onBlur={onBlur}
									placeholder="MH, Sanitaires, Accueil, B-12..."
									style={{ ...inputStyle, borderColor: this.state.ticketLieuOpen ? '#3b82f6' : '#e2e8f0' }}
								/>
							</div>
							{this.state.ticketLieuOpen && (() => {
								const q = (ticketDraft._pitchInput || '').trim().toLowerCase()
								const suggestions = (this.props.pitches || [])
									.filter(p => !q || (p.location || '').toLowerCase().includes(q))
									.slice(0, 8)
								if (suggestions.length === 0)
									return null
								return (
									<div
										data-dd-loc
										style={{ marginTop: '4px', background: 'white', border: '1px solid #e2e8f0', borderRadius: '1rem', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', overflow: 'hidden' }}
									>
										{suggestions.map(p => (
											<button
												key={String(p._id)}
												data-dd-loc
												onClick={() => this.setState(prev => ({ ticketLieuOpen: false, ticketDraft: { ...prev.ticketDraft, _pitchInput: p.location } }))}
												style={{
													backgroundImage: 'none',
													backgroundColor: ticketDraft._pitchInput === p.location ? '#eff6ff' : 'transparent',
													width: '100%',
													padding: '0.75rem 1rem',
													textAlign: 'left',
													fontSize: '0.9375rem',
													fontWeight: 700,
													color: ticketDraft._pitchInput === p.location ? '#2563eb' : '#334155',
													border: 'none',
													borderBottom: '1px solid #f8fafc',
													cursor: 'pointer',
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													gap: '0.75rem',
												}}
											>
												<span>{p.location}</span>
												{(p.zone || p.special_type) && (
													<span style={{ fontSize: '0.6875rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase' }}>{p.zone || p.special_type}</span>
												)}
											</button>
										))}
									</div>
								)
							})()}
							{(ticketDraft._pitchInput || '').trim() !== '' && !this._matchPitch(ticketDraft._pitchInput) && (
								<p style={{ margin: '0.5rem 0 0', fontSize: '0.8125rem', fontWeight: 700, color: '#dc2626' }}>
									Emplacement inconnu : choisissez un emplacement dans la liste.
								</p>
							)}
						</section>

						{/* Accord absence */}
						<div style={{ background: '#f8fafc', padding: '1rem 1.25rem', borderRadius: '1rem', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>
							<div>
								<p style={{ margin: 0, fontSize: '0.9375rem', fontWeight: 700, color: '#1e293b' }}>Accord absence</p>
								<p style={{ margin: 0, fontSize: '0.8125rem', color: '#94a3b8', fontWeight: 500 }}>Autorisation d'intervenir en l'absence du client</p>
							</div>
							<button
								onClick={() => this.setState(prev => ({ ticketDraft: { ...prev.ticketDraft, customer_permission: !prev.ticketDraft.customer_permission } }))}
								style={{ backgroundImage: 'none', backgroundColor: ticketDraft.customer_permission ? '#10b981' : '#e2e8f0', width: '3rem', height: '1.5rem', borderRadius: '9999px', flexShrink: 0, border: 'none', cursor: 'pointer', position: 'relative', transition: 'background-color 0.2s' }}
							>
								<div style={{ position: 'absolute', top: '2px', width: '1.25rem', height: '1.25rem', borderRadius: '9999px', background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s', left: ticketDraft.customer_permission ? 'calc(100% - 1.375rem)' : '2px' }} />
							</button>
						</div>

						{/* Catégorie d'intervention */}
						<section data-dd-cat>
							<label style={sectionLabel}>Catégorie d'intervention</label>
							<div data-dd-cat style={{ position: 'relative' }}>
								<input
									className={inputCls}
									data-dd-cat
									type="text"
									value={ticketCategoryOpen ? ticketCategorySearch : (ticketDraft.category || '')}
									onChange={e => { const v = e.target.value; this.setState({ ticketCategorySearch: v, ticketCategoryOpen: true }) }}
									onFocus={() => this.setState({ ticketCategoryOpen: true, ticketCategorySearch: '' })}
									onBlur={onBlur}
									placeholder="Rechercher une catégorie..."
									style={{ ...inputStyle, borderColor: ticketCategoryOpen ? '#3b82f6' : '#e2e8f0', paddingRight: '2.5rem' }}
								/>
								<span style={{ position: 'absolute', right: '1rem', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#94a3b8' }}>
									<IChevDown />
								</span>
							</div>
							{ticketCategoryOpen && (
								<div
									data-dd-cat
									style={{ marginTop: '4px', background: 'white', border: '1px solid #e2e8f0', borderRadius: '1rem', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', overflow: 'hidden' }}
								>
									{INTERVENTION_CATEGORIES.filter(c => c.toLowerCase().includes(ticketCategorySearch.toLowerCase())).map(c => (
										<button
											key={c}
											data-dd-cat
											onClick={() => this.setState(prev => ({ ticketCategoryOpen: false, ticketCategorySearch: '', ticketDraft: { ...prev.ticketDraft, category: c } }))}
											style={{
												backgroundImage: 'none',
												backgroundColor: ticketDraft.category === c ? '#eff6ff' : 'transparent',
												width: '100%',
												padding: '0.75rem 1rem',
												textAlign: 'left',
												fontSize: '0.9375rem',
												fontWeight: 700,
												color: ticketDraft.category === c ? '#2563eb' : '#334155',
												border: 'none',
												borderBottom: '1px solid #f8fafc',
												cursor: 'pointer',
											}}
										>
											{c}
										</button>
									))}
								</div>
							)}
						</section>

						{/* Urgence */}
						<section>
							<label style={sectionLabel}>Urgence</label>
							<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.5rem' }}>
								{Object.entries(URGENCY_CONFIG).map(([value, cfg]) => {
									const isSelected = ticketDraft.urgency === value
									return (
										<button
											key={value}
											onClick={() => this.setState(prev => ({ ticketDraft: { ...prev.ticketDraft, urgency: value } }))}
											style={{
												backgroundImage: 'none',
												backgroundColor: isSelected ? cfg.activeBg : 'white',
												border: isSelected ? ('2px solid ' + (value === 'NORMAL' ? '#2563eb' : value === 'IMPORTANT' ? '#ea580c' : '#dc2626')) : '2px solid #e2e8f0',
												borderRadius: '1rem',
												padding: '1.25rem 0.5rem',
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'center',
												gap: '0.5rem',
												fontWeight: 700,
												fontSize: '0.6875rem',
												textTransform: 'uppercase',
												letterSpacing: '0.05em',
												color: isSelected ? (value === 'NORMAL' ? '#1d4ed8' : value === 'IMPORTANT' ? '#c2410c' : '#b91c1c') : '#64748b',
												cursor: 'pointer',
												transition: 'transform 0.15s ease, background-color 0.15s ease',
											}}
											onPointerDown={e => { e.currentTarget.style.transform = 'scale(0.93)' }}
											onPointerUp={e => { const el = e.currentTarget; setTimeout(() => { el.style.transform = 'scale(1)' }, 120) }}
											onPointerLeave={e => { e.currentTarget.style.transform = 'scale(1)' }}
										>
											<svg style={{ width: '1.25rem', height: '1.25rem', opacity: isSelected ? 1 : 0.5 }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={cfg.icon} />
											</svg>
											{cfg.label}
										</button>
									)
								})}
							</div>
						</section>
					</div>

					{/* Footer */}
					<div style={{ padding: '1rem 1.5rem 1.5rem', borderTop: '1px solid #f1f5f9', display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', flexShrink: 0 }}>
						<button
							onClick={() => this.setState({ showTicketDialog: false })}
							disabled={creatingTicket}
							style={{ backgroundImage: 'none', backgroundColor: '#f1f5f9', padding: '0.75rem 1.5rem', borderRadius: '0.75rem', fontSize: '0.875rem', fontWeight: 700, color: '#475569', border: 'none', cursor: 'pointer' }}
						>
							Annuler
						</button>
						<button
							onClick={this._handleConfirmTicket}
							disabled={creatingTicket || !this._matchPitch(ticketDraft._pitchInput)}
							style={{ backgroundImage: 'none', backgroundColor: (creatingTicket || !this._matchPitch(ticketDraft._pitchInput)) ? '#94a3b8' : '#2563eb', padding: '0.75rem 1.5rem', borderRadius: '0.75rem', fontSize: '0.875rem', fontWeight: 700, color: 'white', border: 'none', cursor: (creatingTicket || !this._matchPitch(ticketDraft._pitchInput)) ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
						>
							{creatingTicket ? 'Création...' : 'Créer l\'intervention'}
							<IFilePlus />
						</button>
					</div>
				</div>
			</div>
		)
	}

	_getFiltered = () => {
		const { conversations, filterType, searchQuery } = this.state
		if (!conversations) return []
		let list = conversations
		if (filterType === 'resolved')
			list = list.filter(c => c.is_archived === true || c.status === 'resolved')
		else
		{
			list = list.filter(c => !c.is_archived && c.status !== 'resolved')
			if (filterType === 'incident') list = list.filter(c => c.type === 'intervention')
			if (filterType === 'unread') list = list.filter(c => c.read === false)
		}
		const q = searchQuery.trim().toLowerCase()
		if (q) list = list.filter(c => (c.guestName || '').toLowerCase().includes(q))
		return list.slice().sort((a, b) => (b.created_time || 0) - (a.created_time || 0))
	}

	_isStaff = (msg) => {
		if (msg.sender_type === 'staff') return true
		if (msg.sender_type === 'guest') return false
		return msg.user === null || msg.user === undefined
	}

	// Prénom de l'agent (membre du dashboard) qui a rédigé un message staff.
	// Renvoie null si l'id n'est pas résolu (anciens messages, liste non chargée).
	_agentName = (staffUserId) => {
		if (!staffUserId)
			return null
		const users = this.props.dashboard_users || []
		for (let i = 0; i < users.length; i++)
		{
			if (String(users[i]._id) === String(staffUserId))
				return (users[i].firstname || '').trim() || (users[i].username || null)
		}
		return null
	}

	render()
	{
		if (this.props.features !== 'premium') {
			return (
				<>
					<OnlyPremiumEmpty
						title="Messagerie"
						subtitle="Échangez en direct avec vos vacanciers"
						emptyFolder="Pas de conversations"
						emptyFolderSubtitle="Pas de messages"
						navName="Messagerie"
						navPath="/messages/chat"
					/>
					<div className="mt-10">
						<PremiumAlert
							content="Mettez votre abonnement à niveau avec la formule premium pour accéder à la messagerie !"
							button_text="En savoir plus"
						/>
					</div>
				</>
			)
		}

		const { loading, activeConversationId, filterType, searchQuery, searchFocused, textareaFocused, inputText, messagesMap, loadingMessages, openDropdown } = this.state
		const conversations = this.state.conversations || []
		const filtered = this._getFiltered()
		const activeConv = activeConversationId ? conversations.find(c => c._id === activeConversationId) : null
		const activeMessages = activeConversationId ? (messagesMap[activeConversationId] || []) : []
		const unreadCount = conversations.filter(c => c.read === false && !c.is_archived && c.status !== 'resolved').length

		const FILTERS = [
			{ key: 'all', label: 'Tous' },
			{ key: 'incident', label: 'Incidents' },
			{ key: 'unread', label: 'Non lus' },
			{ key: 'resolved', label: 'Résolus' },
		]

		const incidentStatusLabel = (s) => {
			if (s === 'in_progress') return 'En cours'
			if (s === 'resolved') return 'Résolu'
			return 'À traiter'
		}

		const sidebarLeft = this.props.sidebar_collapsed ? '2.25rem' : '16rem'

		return (
			<div
				className="flex bg-[#F9FAFB] text-slate-900 overflow-hidden"
				style={{ position: 'fixed', top: 0, left: this.state.isNarrow ? 0 : sidebarLeft, right: 0, bottom: 0, zIndex: 1 }}
			>

				{/* ── LISTE CONVERSATIONS ── */}
				<section className={`${activeConversationId ? 'hidden lg:flex' : 'flex'} w-full lg:w-96 flex-shrink-0 flex-col bg-white border-r border-slate-200 overflow-hidden shadow-sm`}>

					{/* Header (pl-16 sur mobile pour dégager le bouton menu flottant) */}
					<div className="py-5 pr-5 pl-16 lg:px-5 border-b border-slate-100">
						<div className="flex items-center justify-between mb-4">
							<h1 className="text-xl font-bold tracking-tight text-slate-900 my-0">Conversations</h1>
							<div className="flex items-center gap-2">
								{unreadCount > 0 && (
									<span className="bg-red-500 text-white text-[10px] px-1.5 py-0.5 rounded-full font-bold leading-none">
										{unreadCount}
									</span>
								)}
								<Link
									to="/messages/config"
									className="w-9 h-9 flex items-center justify-center rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
									title="Paramètres"
								>
									<IGear />
								</Link>
							</div>
						</div>
						<div className="relative">
							<span
								className="absolute left-3 top-1/2 -translate-y-1/2 transform pointer-events-none transition-colors"
								style={{ color: searchFocused ? "#3b82f6" : "#94a3b8" }}
							>
								<ISearch />
							</span>
							<input
								type="text"
								placeholder="Rechercher..."
								value={searchQuery}
								onChange={e => this.setState({ searchQuery: e.target.value })}
								onFocus={() => this.setState({ searchFocused: true })}
								onBlur={() => this.setState({ searchFocused: false })}
								className="w-full text-sm text-slate-700 placeholder-slate-400"
								style={{
									height: "2.5rem",
									width: "100%",
									boxSizing: "border-box",
									paddingLeft: "2.25rem",
									paddingRight: "0.75rem",
									backgroundColor: "#f1f5f9",
									border: "none",
									borderBottom: "none",
									borderRadius: "0.5rem",
									boxShadow: searchFocused ? "0 0 0 2px rgba(59,130,246,0.2)" : "none",
									outline: "none",
									margin: 0,
								}}
							/>
						</div>
					</div>

					{/* Filtres */}
					<div className="flex px-4 py-2.5 gap-2 overflow-x-auto border-b border-slate-100">
						{FILTERS.map(f => (
							<button
								key={f.key}
								onClick={() => this.setState({ filterType: f.key })}
								style={{
									backgroundImage: 'none',
									backgroundColor: filterType === f.key ? '#2563eb' : '#f1f5f9'
								}}
								className={`text-xs h-11 lg:h-7 px-4 rounded-full font-semibold whitespace-nowrap transition-colors flex-shrink-0 ${filterType === f.key ? 'text-white' : 'text-slate-600'}`}
							>
								{f.label}
							</button>
						))}
					</div>

					{/* Liste */}
					<div className="flex-1 overflow-y-auto divide-y divide-slate-50">
						{loading && (
							<div className="flex items-center justify-center h-32 text-sm text-slate-400">Chargement...</div>
						)}
						{!loading && filtered.length === 0 && (
							<div className="flex items-center justify-center h-32 text-sm text-slate-400">Aucune conversation</div>
						)}
						{filtered.map(conv => {
							const isActive = conv._id === activeConversationId
							const isUnread = conv.read === false
							return (
								<div
									key={conv._id}
									onClick={() => this._handleSelectConversation(conv._id)}
									className={`cursor-pointer w-full p-4 transition-all border-l-4 ${isActive ? 'bg-blue-50' : 'bg-white hover:bg-slate-50'}`}
									style={{ borderLeftColor: isActive ? '#2563eb' : 'transparent' }}
								>
									<div className="flex items-start justify-between mb-1">
										<div className="flex items-center gap-3">
											<div className="w-10 h-10 rounded-full bg-slate-100 text-slate-600 flex items-center justify-center font-bold text-xs uppercase border-2 border-white ring-1 ring-slate-100 flex-shrink-0">
												{getInitials(conv.guestName)}
											</div>
											<div>
												<div className="flex items-center gap-2">
													<span className={`text-sm ${isUnread ? 'font-bold text-slate-900' : 'font-semibold text-slate-700'}`}>
														{conv.guestName || 'Vacancier'}
													</span>
													{isUnread && (
														<span className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" />
													)}
												</div>
												<span className="text-[10px] text-slate-500 font-medium tracking-tight">
													{conv.pitch || '—'}
												</span>
											</div>
										</div>
										<span className="text-xs font-medium text-slate-500 pt-0.5 flex-shrink-0">
											{formatListDate(conv.created_time)}
										</span>
									</div>
									<p className={`text-xs line-clamp-1 mt-2 mb-2 leading-relaxed ${isUnread ? 'text-slate-950 font-bold' : 'text-slate-500'}`}>
										{conv.title}
									</p>
									<StatusBadge type={conv.type} incidentType={conv.incident_type} />
								</div>
							)
						})}
					</div>
				</section>

				{/* ── ZONE CHAT ── */}
				<section className={`${activeConversationId ? 'flex' : 'hidden lg:flex'} flex-1 flex-col bg-white overflow-hidden relative`}>
					{!activeConv ? (
						<motion.div
							key="empty"
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ duration: 0.15 }}
							className="flex-1 flex flex-col items-center justify-center text-center p-12"
						>
							<span className="text-6xl mb-6 opacity-20 select-none">✉</span>
							<h2 className="text-2xl font-black mb-2 text-slate-900">Messagerie</h2>
							<p className="text-slate-400 font-bold uppercase text-xs tracking-widest">
								Sélectionnez une conversation
							</p>
						</motion.div>
					) : (
						<>
							{/* Header conversation (pl-16 sur mobile pour dégager le bouton menu flottant) */}
							<header className="flex-shrink-0 pr-6 pl-16 lg:px-6 py-3 border-b border-slate-200 flex items-center justify-between gap-4 bg-white z-10">
								<div className="flex items-center gap-3 min-w-0 flex-1">
									{/* Retour à la liste (mobile uniquement) */}
									<button
										onClick={this._handleBackToList}
										aria-label="Retour à la liste"
										style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
										className="lg:hidden flex-shrink-0 w-11 h-11 -ml-2 flex items-center justify-center rounded-lg text-slate-500 hover:text-slate-800 transition-colors"
									>
										<svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
									</button>
									<div className="w-10 h-10 rounded-full bg-slate-100 text-slate-600 flex items-center justify-center font-bold text-xs uppercase border-2 border-slate-100 shadow-sm flex-shrink-0">
										{getInitials(activeConv.guestName)}
									</div>
									<div className="min-w-0">
										<h2 className="text-base font-bold text-slate-900 truncate leading-tight my-2">{activeConv.guestName || 'Vacancier'}</h2>
										<div className="flex items-center gap-2">
											<p className="text-xs text-slate-400 font-bold uppercase tracking-wider truncate">
												{activeConv.pitch || '—'}
											</p>
											{activeConv.title && (
												<>
													<span className="text-slate-300">·</span>
													<span className="inline-flex items-center gap-1 text-xs font-semibold text-slate-500 truncate">
														<IMsg size="w-3 h-3" />
														{activeConv.title}
													</span>
												</>
											)}
										</div>
									</div>
								</div>

								<div className="flex items-center gap-2 flex-wrap">
									{/* Dropdown type incident */}
									{activeConv.type === 'intervention' && (
										<Dropdown
											isOpen={openDropdown === 'incidentType'}
											onClose={() => this.setState({ openDropdown: null })}
											title="Type d'incident"
											items={INCIDENT_TYPES.map(t => ({
												value: t,
												label: t,
												onSelect: () => this._handleUpdate({ incident_type: t })
											}))}
										>
											<button
												data-dd
												onClick={() => this.setState(s => ({ openDropdown: s.openDropdown === 'incidentType' ? null : 'incidentType' }))}
												style={{ backgroundImage: 'none', backgroundColor: '#f8fafc' }}
												className="flex items-center gap-1.5 h-11 lg:h-8 px-3 text-sm font-bold text-slate-700 border border-slate-200 rounded-lg hover:border-slate-300 transition-colors"
											>
												{activeConv.incident_type || 'Type'}
												<IChevDown />
											</button>
										</Dropdown>
									)}

									{/* Dropdown statut */}
									{activeConv.type === 'intervention' && (
										<Dropdown
											isOpen={openDropdown === 'incidentStatus'}
											onClose={() => this.setState({ openDropdown: null })}
											title="Statut"
											items={[
												{ value: 'open', label: 'À traiter', onSelect: () => this._handleUpdate({ status: 'open' }) },
												{ value: 'in_progress', label: 'En cours', onSelect: () => this._handleUpdate({ status: 'in_progress' }) },
												{ value: 'resolved', label: 'Résolu', onSelect: () => this._handleArchive() },
											]}
										>
											<button
												data-dd
												onClick={() => this.setState(s => ({ openDropdown: s.openDropdown === 'incidentStatus' ? null : 'incidentStatus' }))}
												style={{ backgroundImage: 'none', backgroundColor: '#fff7ed' }}
												className="flex items-center gap-1.5 h-11 lg:h-8 px-3 text-sm font-bold text-orange-700 border-none rounded-lg hover:opacity-80 transition-opacity"
											>
												{incidentStatusLabel(activeConv.status)}
												<IChevDown />
											</button>
										</Dropdown>
									)}

									<div className="w-px h-6 bg-slate-200" />

									{/* Marquer résolu */}
									<button
										onClick={this._handleArchive}
										style={{ backgroundImage: 'none', backgroundColor: '#eff6ff' }}
										className="h-11 lg:h-8 px-3 text-sm font-bold text-blue-600 border border-blue-100 rounded-lg hover:opacity-80 transition-opacity"
									>
										Marquer comme résolu
									</button>
								</div>
							</header>

							{/* Messages */}
							<motion.div
								ref={this.scrollRef}
								key={activeConversationId}
								initial={{ opacity: 0, y: 8 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{ duration: 0.2 }}
								className="flex-1 overflow-y-auto bg-slate-50/50 p-3 lg:p-6"
							>
								<div className="max-w-3xl mx-auto w-full space-y-6">
									{loadingMessages && (
										<p className="text-center text-sm text-slate-400 pt-8">Chargement...</p>
									)}
									{!loadingMessages && activeMessages.length === 0 && (
										<p className="text-center text-sm text-slate-400 pt-8">Aucun message</p>
									)}
									{activeMessages.map((msg, idx) => {
										const isBot = msg.sender_type === 'bot'
										const isStaff = this._isStaff(msg)
										return (
											<div key={msg._id || idx} className={`flex gap-3 ${isStaff ? 'flex-row-reverse' : ''}`}>
												<motion.div
													initial={{ opacity: 0, scale: 0.95, y: 10 }}
													animate={{ opacity: 1, scale: 1, y: 0 }}
													transition={{ duration: 0.15, delay: idx * 0.04 }}
													className={`flex flex-col space-y-1 ${isStaff ? 'items-end' : 'items-start'}`}
												>
													<div className={`px-4 py-3 rounded-2xl text-base lg:text-sm shadow-sm max-w-sm lg:max-w-md ${
														isBot
															? 'bg-slate-200 text-slate-600 rounded-tr-none'
															: isStaff
																? 'bg-blue-600 text-white rounded-tr-none'
																: 'bg-white text-slate-700 rounded-tl-none border border-slate-100'
													}`}>
														{msg.message}
													</div>
													<span className="text-xs text-slate-400 font-bold uppercase">
														{isBot
															? 'Réponse automatique · '
															: (isStaff && this._agentName(msg.staff_user))
																? this._agentName(msg.staff_user) + ' · '
																: ''}{formatTime(msg.created_time)}
													</span>
												</motion.div>
											</div>
										)
									})}
								</div>
							</motion.div>

							{/* Footer */}
							<footer className="flex-shrink-0 p-4 lg:p-6 border-t border-slate-200 bg-white">
								<div className="flex gap-2 mb-4 overflow-x-auto">
									{QUICK_REPLIES.map((r, i) => (
										<button
											key={i}
											onClick={() => this._handleSendMessage(r)}
											style={{ backgroundImage: 'none', backgroundColor: 'white' }}
											className="flex-shrink-0 border border-slate-200 rounded-full px-3 py-1.5 text-[11px] font-bold text-slate-600 hover:border-blue-400 hover:text-blue-600 transition-colors whitespace-nowrap"
										>
											<span role="img" aria-label="action rapide">⚡</span> {r}
										</button>
									))}
								</div>
								<div className="flex items-start gap-4">
									<button
										style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
										className="text-slate-400 mt-3 hover:text-slate-600 transition-colors"
									>
										<IClip />
									</button>
									<textarea
										value={inputText}
										onChange={e => this.setState({ inputText: e.target.value })}
										onFocus={() => this.setState({ textareaFocused: true })}
										onBlur={() => this.setState({ textareaFocused: false })}
										onKeyDown={e => {
											if (e.key === 'Enter' && !e.shiftKey)
											{
												e.preventDefault()
												this._handleSendMessage()
											}
										}}
										placeholder="Écrire un message..."
										className="flex-1 rounded-xl bg-slate-50 resize-none text-sm"
										style={{
											height: '80px',
											minHeight: '80px',
											maxHeight: '200px',
											padding: '0.75rem 1rem',
											border: textareaFocused ? '1px solid #60a5fa' : '1px solid #e2e8f0',
											borderBottom: textareaFocused ? '1px solid #60a5fa' : '1px solid #e2e8f0',
											outline: 'none',
											boxShadow: textareaFocused ? '0 0 0 2px rgba(59,130,246,0.15)' : 'none',
											boxSizing: 'border-box',
											margin: 0,
										}}
									/>
									<button
										onClick={() => this._handleSendMessage()}
										style={{ backgroundImage: 'none', backgroundColor: '#2563eb' }}
										className="flex-shrink-0 w-11 h-11 lg:w-10 lg:h-10 mt-1 rounded-xl flex items-center justify-center text-white hover:opacity-90 transition-opacity"
									>
										<ISend />
									</button>
								</div>
							</footer>
						</>
					)}
				</section>

				{/* ── PANNEAU INFOS GUEST ── */}
				{activeConv && (
					<motion.aside
						initial={{ opacity: 0, x: 20 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.25 }}
						className="w-80 bg-white border-l border-slate-200 overflow-y-auto hidden xl:flex flex-col"
					>
						<div className="p-6 border-b border-slate-100 flex-1">
							<h3 className="text-sm font-black text-slate-400 uppercase tracking-widest mb-6 mt-0">Détails du séjour</h3>

							{/* Avatar + nom */}
							<div className="flex flex-col items-center text-center mb-8">
								<div className="w-20 h-20 rounded-full bg-slate-100 text-slate-600 flex items-center justify-center font-bold text-xl uppercase border-4 border-slate-50 shadow-sm mb-4">
									{getInitials(activeConv.guestName)}
								</div>
								<h2 className="text-xl font-bold text-slate-900 leading-tight my-0">{activeConv.guestName || 'Vacancier'}</h2>
								<div className="mt-3">
									<StatusBadge type={activeConv.type} incidentType={activeConv.incident_type} />
								</div>
								{activeConv.title && (
									<p className="mt-2 text-xs font-semibold text-slate-500 bg-slate-50 px-3 py-1.5 rounded-full">
										{activeConv.title}
									</p>
								)}
							</div>

							{/* Séjour */}
							<div className="space-y-3 mb-6">
								{[
									{ icon: <IId />, label: 'N° client', value: activeConv.clientNumber || '—' },
									{ icon: <IPin />, label: 'Emplacement', value: activeConv.pitch || '—' },
									{ icon: <IHome />, label: 'Catégorie', value: activeConv.stayCategory || '—' },
									{ icon: <ICal />, label: 'Dates de séjour', value: activeConv.stayDates || '—' },
								].map(({ icon, label, value }) => (
									<div key={label} className="flex items-start gap-4 my-6">
										<div className="w-8 h-8 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center flex-shrink-0">
											{icon}
										</div>
										<div>
											<p className="text-[10px] font-bold text-slate-400 uppercase tracking-tighter">{label}</p>
											<p className="text-sm font-bold text-slate-700">{value}</p>
										</div>
									</div>
								))}
							</div>

							<hr className="border-slate-100 mb-6" />

							{/* Contact */}
							<div className="space-y-4">
								<div className="flex items-center gap-3 text-slate-400">
									<IPhone />
									<p className="text-sm font-medium text-slate-600">{activeConv.guestPhone || 'Non renseigné'}</p>
								</div>
								<div className="flex items-center gap-3 text-slate-400">
									<IMail />
									<p className="text-sm font-medium text-slate-600 truncate">{activeConv.guestEmail || 'Non renseigné'}</p>
								</div>
							</div>

							{/* Notes internes d'équipe */}
							<hr className="border-slate-100 my-6" />
							<div>
								<h3 className="text-sm font-black text-slate-400 uppercase tracking-widest mb-1 mt-0">Notes internes</h3>
								<p className="text-xs text-amber-600 font-semibold mb-3">Visible par l'équipe uniquement · jamais par le vacancier</p>

								<div className="space-y-2 mb-3">
									{this.state.loadingNotes && (this.state.notesMap[activeConv._id] === undefined) && (
										<p className="text-xs text-slate-400">Chargement…</p>
									)}
									{(this.state.notesMap[activeConv._id] || []).map(n => (
										<div key={n._id} className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
											<p className="text-sm text-amber-900 whitespace-pre-wrap break-words my-0">{n.note}</p>
											<div className="flex items-center justify-between mt-1">
												<span className="text-xs text-amber-600 font-bold uppercase">
													{this._agentName(n.staff_user) || 'Équipe'} · {formatTime(n.created_time)}
												</span>
												<button
													onClick={() => this._handleDeleteNote(n._id)}
													style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
													className="text-xs font-bold text-amber-400 hover:text-red-500 transition-colors"
												>
													Supprimer
												</button>
											</div>
										</div>
									))}
									{!this.state.loadingNotes && (this.state.notesMap[activeConv._id] || []).length === 0 && (
										<p className="text-xs text-slate-400 italic">Aucune note pour l'instant</p>
									)}
								</div>

								<textarea
									value={this.state.noteInput}
									onChange={e => { const v = e.target.value; this.setState({ noteInput: v }) }}
									onFocus={() => this.setState({ noteFocused: true })}
									onBlur={() => this.setState({ noteFocused: false })}
									onKeyDown={e => {
										if (e.key === 'Enter' && !e.shiftKey)
										{
											e.preventDefault()
											this._handleAddNote()
										}
									}}
									placeholder="Ajouter une note pour l'équipe…"
									className="w-full text-sm rounded-lg resize-none"
									style={{
										minHeight: '3rem',
										padding: '0.5rem 0.75rem',
										border: this.state.noteFocused ? '1px solid #f59e0b' : '1px solid #fde68a',
										borderBottom: this.state.noteFocused ? '1px solid #f59e0b' : '1px solid #fde68a',
										backgroundColor: '#fffbeb',
										color: '#78350f',
										outline: 'none',
										boxSizing: 'border-box',
										margin: 0,
									}}
								/>
								<button
									onClick={this._handleAddNote}
									disabled={!this.state.noteInput.trim()}
									style={{ backgroundImage: 'none', backgroundColor: this.state.noteInput.trim() ? '#d97706' : '#fcd34d' }}
									className="w-full mt-2 px-4 py-2 text-white font-bold text-xs rounded-lg transition-opacity hover:opacity-90"
								>
									Ajouter une note
								</button>
							</div>
						</div>

						{/* Actions bas */}
						<div className="p-6 space-y-3 border-t border-slate-100">
							{this.state.ticketFeedback && (
								<p className={`text-xs font-bold text-center my-2 ${this.state.ticketFeedback.type === 'success' ? 'text-emerald-600' : 'text-red-600'}`}>
									{this.state.ticketFeedback.text}
								</p>
							)}
							<button
								onClick={this._handleOpenTicketDialog}
								disabled={this.state.creatingTicket || activeConv.ticket_created === true}
								style={{ backgroundImage: 'none', backgroundColor: activeConv.ticket_created === true ? '#64748b' : '#0f172a' }}
								className="w-full flex items-center justify-between px-6 py-3 text-white font-bold text-sm rounded-xl shadow-lg shadow-slate-200"
							>
								{this.state.creatingTicket ? 'Création...' : (activeConv.ticket_created === true ? 'Ticket créé' : 'Créer un ticket')}
								<IFilePlus />
							</button>
						</div>
					</motion.aside>
				)}
				{this._renderTicketDialog()}
			</div>
		)
	}
}

export default MessagerieAll
